/**
 * Copyright 2023 Google LLC.
 * Copyright (c) Microsoft Corporation.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
export * as Cdp from './cdp.js';
export * as ChromiumBidi from './chromium-bidi.js';
export * from './generated/webdriver-bidi.js';
export * from './ErrorResponse.js';
export * from './generated/webdriver-bidi-permissions.js';
export * from './generated/webdriver-bidi-bluetooth.js';
export * from './generated/webdriver-bidi-nav-speculation.js';
export * from './generated/webdriver-bidi-digital-credentials.js';
// Alias is required, as `UAClientHints` spec defines `Emulation` namespace.
export * as UAClientHints from './generated/webdriver-bidi-ua-client-hints.js';
